import { combineReducers } from 'redux';

import {
  createArticleCommentRequest,
  createArticleCommentFail,
  createArticleCommentSuccess,
  setArticleCommentMessage,
  setArticleCommentFocusStatus, clearArticleComment,
} from '../actions';
import { ArticleCommentAction } from '../types';
import { Reducer } from '../../../types';

export type ArticleCommentState = {
  data: string;
  loading: boolean;
  isFocused: boolean;
};
type ReducerOf<T extends keyof ArticleCommentState> = Reducer<ArticleCommentState, ArticleCommentAction, T>;

const data: ReducerOf<'data'> = (state = '', action: ArticleCommentAction) => {
  switch (action.type) {
    case createArticleCommentSuccess.type:
      return '';
    case setArticleCommentMessage.type:
      return action.payload;
    case clearArticleComment.type:
      return '';
    default:
      return state;
  }
};


const loading: ReducerOf<'loading'> = (state = false, action) => {
  switch (action.type) {
    case createArticleCommentRequest.type:
      return true;

    case createArticleCommentFail.type:
    case createArticleCommentSuccess.type:
      return false;

    default:
      return state;
  }
};

const isFocused: ReducerOf<'isFocused'> = (state = false, action) => {
  switch (action.type) {
    case setArticleCommentFocusStatus.type:
      return action.payload;

    default:
      return state;
  }
};

export default combineReducers<ArticleCommentState>({
  data,
  loading,
  isFocused,
});
